
<template>
	<dialog-slot
			:title="title"
			@updateClose="onClose"
			:is-cancel-hide="!isClose"
			:cancel-text="textClose"
			@updateSave="onApply"
			:is-save="isApply"
			:apply-text="textApply"
			:width="width"
	>
		<div class="text" v-html="text"></div>
	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

export default {
	name: "DialogInfo",
	components: { DialogSlot },
	props: {
		title: String,
		line: String,
		width: {
			type: [ Number, String ],
			default: () => '640'
		},

		textApply: {
			type: [ String ],
			default: () => 'Ok'
		},
		isApply: {
			type: Boolean,
			default: () => true
		},

		textClose: {
			type: [ String ],
			default: () => 'Close'
		},
		isClose: {
			type: Boolean,
			default: () => false
		},
	},
	data: () => ({
		isDialogRemove: true,
	}),
	methods: {
		onApply() {
			this.$emit('updateApply');
		},
		onClose() {
			this.$emit('updateClose');
		},
	},
};
</script>

<style scoped lang="scss">
@import "../../components/Dispatch/Trips/DialogTrip/dialog";
</style>
